/**
 * <SettingsSectionSkeleton> — la forme d'un groupe de réglages pendant son chargement.
 *
 * La carte, l'intitulé vrai (il ne dépend d'aucune donnée) et des lignes à la hauteur des
 * vraies : un glyphe, un libellé, un filet entre deux.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Divider } from "../../atoms/Divider"
import { Row } from "../../atoms/containers/Row"
import { Skeleton } from "../../atoms/Skeleton"
import { SectionLabel } from "../../atoms/typography/SectionLabel"
import { Card } from "../Card"
import { SETTING_ROW_MIN_HEIGHT } from "../SettingRow"
import { settingsSectionStyles } from "./SettingsSection"

export type SettingsSectionSkeletonProps = {
    title?: string
    /** Nombre de lignes montrées. */
    rows: number
    /** Les lignes ont un glyphe de tête. Défaut `true`. */
    withIcon?: boolean
}

export function SettingsSectionSkeleton(props: SettingsSectionSkeletonProps) {
    const { title, rows, withIcon = true } = props

    return (
        <Card p="4">
            {title != null && <SectionLabel style={settingsSectionStyles.title}>{title}</SectionLabel>}
            {Array.from({ length: rows }, (_, index) => (
                <React.Fragment key={index}>
                    {index > 0 && <Divider spacing="1" />}
                    <Row gap="3" align="center" style={styles.row}>
                        {withIcon && <Skeleton shape="circle" size={20} />}
                        <Skeleton textSize="text-base" width={180} />
                    </Row>
                </React.Fragment>
            ))}
        </Card>
    )
}

const styles = StyleSheet.create((theme) => ({
    row: {
        minHeight: SETTING_ROW_MIN_HEIGHT,
        paddingVertical: theme.spacing["2"],
    },
}))
